import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const kitItems = [{
  title: 'Guía inicial',
  desc: 'Una guía clara y visual para entender el proceso y dar tus primeros pasos en el mundo del tricotín.',
  img: 'https://cdn.magicpatterns.com/uploads/tBn3cuw8iqPkK6Kr47Lh11/guia_inicial.webp',
  tag: '1'
}, {
  title: '+200 moldes para comenzar a diseñar',
  desc: 'Una colección de moldes pensada para ayudarte a crear piezas lindas, prolijas y con más variedad desde el principio.',
  img: 'https://cdn.magicpatterns.com/uploads/15vxk5PD8CfoLvKeQUzmKq/200_plantillas.jpg',
  tag: '2'
}, {
  title: 'Guía para aprender a emprender desde casa',
  desc: 'Un recurso pensado para mostrarte cómo llevar esta habilidad más allá del hobby y empezar a verla como una oportunidad real para generar ingresos extra.',
  img: 'https://cdn.magicpatterns.com/uploads/eZgBjctwxgmWnuneUmf4BY/GUIA_DE_EMPRENDIMIENTO.png',
  tag: '3'
}];
export function KitContents() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-brand-alt-bg/30" data-id="element-83">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-84">
        <span className="inline-block py-1 px-3 rounded-full bg-brand-accent/20 text-brand-deep-green text-sm font-bold tracking-wider uppercase mb-4" data-id="element-85">
          APRENDÉ DESDE CERO
        </span>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl text-brand-text mb-6" data-id="element-86">
          Tu Mega Kit de Tricotín Creativo
        </h2>
        <p className="text-lg sm:text-xl text-brand-text/80 leading-relaxed" data-id="element-87">
          Tres recursos clave para aprender desde cero, crear con seguridad y
          empezar a transformar esta habilidad en una oportunidad desde casa
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-88">
        {kitItems.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: i * 0.15
      }} className="bg-brand-card rounded-[2rem] overflow-hidden shadow-lg border border-brand-accent/10 flex flex-col" data-id="element-89">
            <div className="relative aspect-[4/5] bg-brand-alt-bg/50 p-6 flex items-center justify-center" data-id="element-90">
              <img src={item.img} alt={item.title} className="w-full h-full object-contain drop-shadow-xl rounded-xl" data-id="element-91" />
              <div className="absolute top-4 right-4 bg-brand-card/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-brand-deep-green flex items-center gap-1 shadow-sm" data-id="element-92">
                <CheckCircle2 size={14} data-id="element-93" />
                {item.tag}
              </div>
            </div>

            <div className="p-8 flex-1 flex flex-col" data-id="element-94">
              <h3 className="text-2xl text-brand-text font-serif mb-4 leading-tight" data-id="element-95">
                {item.title}
              </h3>
              <p className="text-brand-text/70 font-sans leading-relaxed text-sm sm:text-base flex-1" data-id="element-96">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}